// extracted by mini-css-extract-plugin
export default {"root":"Footer-module_root_c4ff3d"};